import { Routes, Route, Navigate, useParams } from "react-router-dom";
import { lazy, Suspense } from "react";
import { Loading } from "@ottatech/shared-components";

import Jobs from ".";

import { CandidateRoute } from "utils/routing/CandidateRoute";
import { PreferencesSetRoute } from "utils/routing/PreferencesSetRoute";

const Application = lazy(() => import("pages/Profile/Application/index"));
const ApplicationPreview = lazy(
  () => import("pages/Profile/Application/Preview")
);
const ApplicationView = lazy(() => import("./Applications/ApplicationView"));

function RedirectFromSectors() {
  const { sectorTagId } = useParams();

  return (
    <Navigate to={`/jobs/theme/preferred-sector/${sectorTagId}`} replace />
  );
}

export default function JobsRoutes(): React.ReactElement {
  return (
    <Routes>
      <Route path="saved" element={<Navigate replace to="/" />} />
      <Route
        path="preferences"
        element={<Navigate replace to="/preferences" />}
      />
      <Route
        path=":jobId/apply"
        element={
          <CandidateRoute>
            <Suspense fallback={<Loading />}>
              <Application />
            </Suspense>
          </CandidateRoute>
        }
      />
      <Route
        path=":jobId/application"
        element={
          <CandidateRoute>
            <Suspense fallback={<Loading />}>
              <ApplicationView />
            </Suspense>
          </CandidateRoute>
        }
      />
      <Route
        path=":jobId/apply/preview"
        element={
          <CandidateRoute>
            <Suspense fallback={<Loading />}>
              <ApplicationPreview />
            </Suspense>
          </CandidateRoute>
        }
      />
      <Route
        path="theme/preferred-sector/:sectorTagId/*"
        element={
          <PreferencesSetRoute
            element={
              <Suspense fallback={<Loading />}>
                <Jobs />
              </Suspense>
            }
          />
        }
      />
      <Route
        path="theme/:themeId/*"
        element={
          <PreferencesSetRoute
            element={
              <Suspense fallback={<Loading />}>
                <Jobs />
              </Suspense>
            }
          />
        }
      />

      <Route path="sector/:sectorTagId/*" element={<RedirectFromSectors />} />

      <Route
        path="*"
        element={
          <PreferencesSetRoute
            element={
              <Suspense fallback={<Loading />}>
                <Jobs />
              </Suspense>
            }
            fallback={
              <Suspense fallback={<Loading />}>
                <Jobs isPublic />
              </Suspense>
            }
          />
        }
      />
    </Routes>
  );
}
